export const isDesktop = () => window.matchMedia("(min-width: 1000px)").matches;
